import { StateService } from "./_services/state.service";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { RouterModule } from "@angular/router";

import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatNativeDateModule } from "@angular/material/core";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatListModule } from "@angular/material/list";
import { MatCardModule } from "@angular/material/card";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatChipsModule } from "@angular/material/chips";
import { MatDividerModule } from "@angular/material/divider";
import { DragDropModule } from "@angular/cdk/drag-drop";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app.routing";
import { Globals } from "./globals";
import { AuthService } from "./_services/auth.service";
import { FilterPipe } from "./filter.pipe";
import { SafeHtml } from "./safe-html.pipe.";
import { NeedAuthGuard } from "./_shared/NeedAuthGuard ";
import { Tools } from "./_shared/tools";
import { LoginComponent } from "./login/login.component";
import { HomeComponent } from "./home/home.component";
import { HeaderComponent } from "./header/header.component";
import { MainMenuComponent } from "./main-menu/main-menu.component";
import { LoaderComponent } from "./loader/loader.component";
import { ProductsComponent } from "./products/products.component";
import { ProductListComponent } from "./product-list/product-list.component";
import { ProductViewComponent } from "./product-view/product-view.component";
import { ProductService } from "./_services/product.service";
import { ProductAddComponent } from "./product-add/product-add.component";
import { CountryService } from "./_services/country.service";
import { CountryPricingCollapsibleComponent } from "./country-pricing-collapsible/country-pricing-collapsible.component";
import { AdjustmentPriceFormComponent } from "./adjustment-price-form/adjustment-price-form.component";
import { ImageUploadDialogComponent } from "./image-upload-dialog/image-upload-dialog.component";
import { MatDialogModule } from "@angular/material/dialog";
import { FileService } from "./_services/file.service";
import { CountryListPageComponent } from "./country-list-page/country-list-page.component";
import { AddCountryPageComponent } from "./add-country-page/add-country-page.component";
import { CourierListPageComponent } from "./courier-list-page/courier-list-page.component";
import { CourierService } from "./_services/courier.service";
import { ViewCountryPageComponent } from "./view-country-page/view-country-page.component";
import { AddCourierPageComponent } from "./add-courier-page/add-courier-page.component";
import { ViewCourierPageComponent } from "./view-courier-page/view-courier-page.component";
import { StatesListPageComponent } from "./states-list-page/states-list-page.component";
import { AddStatePageComponent } from "./add-state-page/add-state-page.component";
import { ViewStatePageComponent } from "./view-state-page/view-state-page.component";
import { CityListPageComponent } from "./city-list-page/city-list-page.component";
import { AddCityPageComponent } from "./add-city-page/add-city-page.component";
import { ViewCityPageComponent } from "./view-city-page/view-city-page.component";
import { ZoneListPageComponent } from "./zone-list-page/zone-list-page.component";
import { AddZonePageComponent } from "./add-zone-page/add-zone-page.component";
import { ViewZonePageComponent } from "./view-zone-page/view-zone-page.component";
import { EditPriceDialogComponent } from "./edit-price-dialog/edit-price-dialog.component";
import { TokenInterceptor } from "./_shared/TokenInterceptor";
import { BundleItemsComponent } from './views/bundle-items/bundle-items.component';

@NgModule({
  declarations: [
    AppComponent,
    FilterPipe,
    SafeHtml,
    HomeComponent,
    ProductsComponent,
    ProductListComponent,
    ProductViewComponent,
    LoginComponent,
    HeaderComponent,
    MainMenuComponent,
    LoaderComponent,
    ProductAddComponent,
    CountryPricingCollapsibleComponent,
    AdjustmentPriceFormComponent,
    ImageUploadDialogComponent,
    CountryListPageComponent,
    AddCountryPageComponent,
    CourierListPageComponent,
    ViewCountryPageComponent,
    AddCourierPageComponent,
    ViewCourierPageComponent,
    StatesListPageComponent,
    AddStatePageComponent,
    ViewStatePageComponent,
    CityListPageComponent,
    AddCityPageComponent,
    ViewCityPageComponent,
    ZoneListPageComponent,
    AddZonePageComponent,
    ViewZonePageComponent,
    EditPriceDialogComponent,
    BundleItemsComponent,
  ],
  imports: [
    NgbModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatFormFieldModule,
    MatSelectModule,
    MatExpansionModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatCheckboxModule,
    MatIconModule,
    MatMenuModule,
    MatListModule,
    MatCardModule,
    MatSnackBarModule,
    MatChipsModule,
    MatDividerModule,
    DragDropModule,
    MatDialogModule,
  ],
  providers: [
    MatNativeDateModule,
    Globals,
    Tools,
    NeedAuthGuard,
    AuthService,
    ProductService,
    CountryService,
    FileService,
    CourierService,
    StateService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  ],
  entryComponents: [EditPriceDialogComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
